// GET /admin/v1/ads/stats (contracts/ads.md §3 "Admin"; backend/api src/schemas/ads.ts AdminAdsStats).
// Counters default to 0 and lists to [], so a backend that sends fewer fields still parses.

import { z } from "zod";

const n = z.number().int().min(0).catch(0);
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const ByPlacement = z.object({
  rewardedExtraLevels: n,
  rewardedHint: n,
  rewardedStreakFreeze: n,
  rewardedArchivePuzzle: n,
  rewardedLevelRetry: n,
});
export type ByPlacement = z.infer<typeof ByPlacement>;
const zero = { rewardedExtraLevels: 0, rewardedHint: 0, rewardedStreakFreeze: 0, rewardedArchivePuzzle: 0, rewardedLevelRetry: 0 };

export const AdsStatsDay = z.object({
  date: isoDate,
  intents: n,
  granted: n,
  grants: ByPlacement.catch(zero),
  ssvVerified: n,
  expired: n,
});
export type AdsStatsDay = z.infer<typeof AdsStatsDay>;

export const AdsStats = z.object({
  from: isoDate,
  to: isoDate,
  days: z.array(AdsStatsDay),
  totals: z.object({
    intents: n,
    granted: n,
    expired: n,
    open: n,
    grants: ByPlacement.catch(zero),
    bonusLevels: n,
    freezes: n,
    freezesDropped: n,
    archiveUnlocks: n,
    testMode: n,
    byProvider: z.object({ admanager: n, admob: n }).catch({ admanager: 0, admob: 0 }),
  }),
  ssv: z.object({ verified: n, unverified: n }),
  abuse: z.object({
    earlyClaims: n,
    nearFloor: n,
    burst: n,
    unitMismatch: n,
    repeatClaims: n,
    rateLimited: n,
    sharedIps: n,
    topPlayers: z.array(z.object({ userId: z.string(), grants: n, flagged: n })).catch([]),
  }),
  fill: z
    .object({ requests: n, filled: n, ratio: z.number().min(0).max(1).nullable() })
    .nullable()
    .catch(null),
});
export type AdsStats = z.infer<typeof AdsStats>;
